export default __webpack_public_path__ + "static/media/slopedEdgeIcon.81ecd8b2.webp";